module.exports = __webpack_public_path__ + "images/evnet7cf3000da57d8939a57f4d6c19d36f71.png";